module.exports = __webpack_public_path__ + "static/media/seven_monkeys.000a91fd.gif";